import { createRef, useCallback, useMemo, useRef, useState } from 'react'
import moment, { Moment } from 'moment'
import { InputRef } from '@components/base'

export const useCodeStates = (length: number) => {
  const allCodeRefs = useMemo(() => Array.from({ length }, () => createRef<InputRef>()), [length])
  const [codes, setCodes] = useState(() => Array(length).fill(''))

  return { allCodeRefs, codes, setCodes }
}

export const useTimer = (durationSeconds: number) => {
  const [secondsLeft, setSecondsLeft] = useState<number>(durationSeconds)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const startedAtRef = useRef<Moment | null>(null)

  const startCounter = useCallback(() => {
    startedAtRef.current = moment()

    if (intervalRef.current) {
      clearInterval(intervalRef.current)
    }

    intervalRef.current = setInterval(() => {
      setSecondsLeft(() => {
        const newSecondsLeft = durationSeconds - moment().diff(startedAtRef.current, 'seconds')
        newSecondsLeft < 1 && clearInterval(intervalRef.current!)
        return newSecondsLeft
      })
    }, 1000)
  }, [durationSeconds, startedAtRef])

  return { secondsLeft, startCounter }
}

export const calculateLeftTime = (timerCount: number) => {
  if (timerCount < 1) {
    return '00:00'
  }

  const leftMinutes = ('0' + Math.floor(timerCount / 60)).slice(-2)
  const leftSeconds = ('0' + (timerCount % 60)).slice(-2)

  return [leftMinutes, leftSeconds].join(':')
}

export const maskPhoneNumber = (phoneNumber: string) => {
  const last4Digits = phoneNumber.slice(-4)
  return last4Digits.padStart(phoneNumber.length, '*')
}
